import { useCallback } from "react";


export const useDebounce = (fun, timeout, deps) => {
    function debounce(func, wait, immediate) {
        let timeout;

        return (...args) => {
            let context = this;

            let later = () => {
                timeout = null;
                if (!immediate) func.apply(context, args);
            };

            let callNow = immediate && !timeout;

            clearTimeout(timeout);

            timeout = setTimeout(later, wait);

            if (callNow) func.apply(context, args);
        };
    }

    return useCallback(debounce(fun, timeout), deps);
}
